import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import horizonImage from '@/assets/leaders-threshold-horizon.jpg';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const LeadersThreshold = () => {
  const handleScheduleCall = () => {
    window.open('https://calendly.com/kentfrazier/30-minutes', '_blank');
  };

  const content = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      {/* Painterly horizon background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${horizonImage})` }}
        aria-hidden="true"
      />
      {/* Layered overlays for legibility */}
      <div className="absolute inset-0 bg-foreground/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground/50 via-foreground/40 to-foreground/85" />
      {/* Centered radial darkener behind the headline */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at center, hsl(var(--foreground) / 0.55) 0%, transparent 65%)',
        }}
        aria-hidden="true"
      />

      <div
        ref={content.ref}
        className={`container-mobile relative z-10 max-w-4xl mx-auto py-32 sm:py-40 text-center transition-all duration-1000 ${
          content.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <h2
          className="text-background text-4xl sm:text-5xl lg:text-6xl mb-10 leading-[1.05]"
          style={{
            textWrap: 'balance',
            textShadow: '0 2px 24px hsl(var(--foreground) / 0.9), 0 0 8px hsl(var(--foreground) / 0.7)',
          }}
        >
          I can't afford my current way of being.
        </h2>

        <p className="text-background/90 text-xl sm:text-2xl leading-relaxed mb-14 max-w-2xl mx-auto font-normal drop-shadow">
          Thirty minutes to explore what matters, what's at stake, and fit.
        </p>

        <Button
          onClick={handleScheduleCall}
          size="lg"
          className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold text-lg px-10 py-7 rounded-full transition-all duration-300 hover:shadow-2xl hover:shadow-primary/30 hover:scale-105"
        >
          Schedule a call
          <ArrowRight className="h-5 w-5 ml-2" />
        </Button>
      </div>
    </section>
  );
};

export default LeadersThreshold;
